import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import type { Role } from "@/api/auth";
import { useAuthStore } from "@/state/auth.store";

const RANK: Record<Role, number> = {
  employee: 0,
  manager: 1,
  org_admin: 2,
  platform_admin: 3,
};

export function ProtectedRoute({ children, minRole }: { children: ReactNode; minRole?: Role }) {
  const { token, user, hydrated } = useAuthStore();

  if (!token) return <Navigate to="/login" replace />;
  if (!hydrated) return <div className="center-col">Laden…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (minRole && RANK[user.role] < RANK[minRole]) return <Navigate to="/app" replace />;

  return <>{children}</>;
}
